import { Component } from '@theme/component';
class PurBuilder extends Component {
  connectedCallback() { super.connectedCallback(); this.setup(); }
  updatedCallback() { super.updatedCallback(); this.setup(); }
  setup() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"]')) this.selectScent();
      if (event.target.matches('select[name="id"]')) this.updateVariant(event.target);
    }, { signal: this.controller.signal });
    this.addEventListener('click', event => {
      const button = event.target.closest('button[data-variant]');
      if (!button || !this.contains(button) || button.disabled) return;
      const select = button.closest('form').querySelector('select[name="id"]');
      select.value = button.dataset.variant;
      this.updateVariant(select);
    }, { signal: this.controller.signal });
    for (const grid of this.querySelectorAll('.ps-builder__bottle-grid')) grid.hidden = false;
    this.selectScent();
  }
  selectScent() {
    const selected = this.querySelector('input[type="radio"]:checked') || this.querySelector('input[type="radio"]');
    if (!selected) return;
    selected.checked = true;
    for (const panel of this.querySelectorAll('[data-product]')) {
      panel.hidden = panel.dataset.product !== selected.value;
      if (!panel.hidden) this.updateVariant(panel.querySelector('select[name="id"]'));
    }
  }
  updateVariant(select) {
    if (!select) return;
    const option = select.selectedOptions[0];
    if (!option) return;
    const form = select.closest('form');
    for (const button of form.querySelectorAll('[data-variant]')) button.setAttribute('aria-pressed', String(button.dataset.variant === option.value));
    form.querySelector('[data-bottle]').textContent = option.textContent;
    form.querySelector('.ps-builder__summary [data-price]').textContent = option.dataset.price;
    const image = form.querySelector('.ps-builder__preview');
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; image.alt = option.textContent; }
    const quantity = form.querySelector('[name="quantity"]');
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.increment || '1';
    if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
    const minimum = Number(quantity.min), increment = Number(quantity.step), maximum = Number(quantity.max || Infinity);
    const proposed = Math.max(minimum, Number(quantity.value) || minimum);
    quantity.value = String(Math.min(maximum, minimum + Math.ceil((proposed - minimum) / increment) * increment));
    form.querySelector('[type="submit"]').disabled = option.disabled;
  }
  disconnectedCallback() { this.controller?.abort(); super.disconnectedCallback(); }
}
if (!customElements.get('ps-builder')) customElements.define('ps-builder', PurBuilder);
